import * as React from 'react'
import { Redirect, RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import ServiceArchiveModal from '../../containers/services/ServiceArchiveModal'
import ServiceCreatePane from '../../containers/services/ServiceCreatePane'
import ServiceEditPane from '../../containers/services/ServiceEditPane'
import ServiceRestoreModal from '../../containers/services/ServiceRestoreModal'
import ServiceViewPane from '../../containers/services/ServiceViewPane'
import ModivcareTripLogPDF from '../../containers/services/ModivcareTripLogPDF'
import AfterHoursReportPDF from '../../containers/services/AfterHoursReportPDF'
import ServiceListPane from './list/ServiceListPane'
import ErrorBoundary from '../ErrorBoundary'
import { IServiceStateFilters } from 'src/types/service'

const ListRedirect = (props: RouteComponentProps<any>) => <Redirect to={`${props.match.path}/list`} />

interface IServicePaneProps {
  showArchiveModal: boolean
  showRestoreModal: boolean
  orgId: string
  routeProps: RouteComponentProps<any>
  updateServiceFilters: (params: IServiceStateFilters) => Promise<any>
}
//Declaration of URL's
const getLink = (): string => {
  let link = ''
  if (process.env.REACT_APP_GATEWAY_URL) {
    link = process.env.REACT_APP_GATEWAY_URL
    if (process.env.REACT_APP_GATEWAY_URL.includes('dev')) {
      const lnk = process.env.REACT_APP_GATEWAY_URL.split(':')
      link = lnk[1]
    } else if (process.env.REACT_APP_GATEWAY_URL.includes('radar')) {
      const lnk1 = process.env.REACT_APP_GATEWAY_URL.split(':')
      link = lnk1[1]
    }
  }
  return link
}
//Declaration of URL's
const ServicePane = (props: IServicePaneProps) => {
  const { showArchiveModal, showRestoreModal, routeProps } = props
  React.useEffect(() => {
    props.updateServiceFilters({ organizationId: props.orgId })
  })
  return (
    <ErrorBoundary>
      <React.Fragment>
        <Switch>
          <Route exact={true} path={`${routeProps.match.path}`} render={ListRedirect} />
          <Route path={`${routeProps.match.path}/create`} component={ServiceCreatePane} />
          <Route path={`${routeProps.match.path}/list`} component={ServiceListPane} />
          <Route path={`${routeProps.match.path}/:id/edit`} component={ServiceEditPane} />
          <Route path={`${routeProps.match.path}/:id`} component={ServiceViewPane} />
        </Switch>

        {/* Footer */}
        <div
          className='footer-copyright border-box text-left py-3 font-black h6 bold '
          style={{
            marginBottom: '5rem',
            marginTop: '5rem',
            marginLeft: '1rem'
          }}
        >
          &copy; Copyright {new Date().getFullYear()}{' '}
          <a href={`${getLink()}`}>
            <u>GOIN'</u>
          </a>{' '}
          All rights reserved.
        </div>
        {/* Footer */}

        {showArchiveModal && <ServiceArchiveModal />}
        {showRestoreModal && <ServiceRestoreModal />}
      </React.Fragment>
    </ErrorBoundary>
  )
}

export default ServicePane



// WEBPACK FOOTER //
// ./src/components/services/ServicePane.tsx